/* Duftfinder — data-driven scent quiz. Reads product metafields + i18n from the
   section's JSON script tags, derives finder tags, scores products, renders result. */
(function () {
  var ICON = {
    sie:'<svg viewBox="0 0 32 32"><circle cx="16" cy="12" r="7"/><path d="M16 19v9M11 25h10"/></svg>',
    ihn:'<svg viewBox="0 0 32 32"><circle cx="13" cy="19" r="7"/><path d="M18 14l8-8M20 6h6v6"/></svg>',
    egal:'<svg viewBox="0 0 32 32"><path d="M8 20a5 5 0 1 0 5-5M24 12a5 5 0 1 0-5 5"/></svg>',
    frisch:'<svg viewBox="0 0 32 32"><path d="M16 4C10 12 8 15 8 20a8 8 0 0 0 16 0c0-5-2-8-8-16Z"/></svg>',
    fruchtig:'<svg viewBox="0 0 32 32"><circle cx="16" cy="19" r="9"/><path d="M16 10c0-4 3-6 6-6-1 4-3 6-6 6Z"/></svg>',
    bluemig:'<svg viewBox="0 0 32 32"><circle cx="16" cy="16" r="4"/><path d="M16 12V4M16 20v8M12 16H4M20 16h8M12.5 12.5 7 7M19.5 19.5 25 25M19.5 12.5 25 7M12.5 19.5 7 25"/></svg>',
    warm:'<svg viewBox="0 0 32 32"><path d="M18 3c1 5-3 6-3 11a5 5 0 0 0 8 4c1 6-3 11-7 11a9 9 0 0 1-4-17c3-2 5-5 6-9Z"/></svg>',
    holzig:'<svg viewBox="0 0 32 32"><path d="M16 28V8M16 14l-6-5M16 18l6-5M16 8l-4-4M16 8l4-4"/></svg>',
    alltag:'<svg viewBox="0 0 32 32"><circle cx="16" cy="16" r="11"/><path d="M16 9v7l5 3"/></svg>',
    buero:'<svg viewBox="0 0 32 32"><rect x="6" y="10" width="20" height="16"/><path d="M12 10V6h8v4"/></svg>',
    abend:'<svg viewBox="0 0 32 32"><path d="M22 18a9 9 0 1 1-8-12 7 7 0 0 0 8 12Z"/></svg>',
    ganzjaehrig:'<svg viewBox="0 0 32 32"><circle cx="16" cy="16" r="10"/><path d="M6 16h20M16 6c4 4 4 16 0 20M16 6c-4 4-4 16 0 20"/></svg>',
    i1:'<svg viewBox="0 0 32 32"><path d="M8 20h4V14H8z"/><path d="M14 20h4v-9h-4z" opacity=".35"/><path d="M20 20h4V8h-4z" opacity=".15"/></svg>',
    i2:'<svg viewBox="0 0 32 32"><path d="M8 20h4V14H8zM14 20h4v-9h-4z"/><path d="M20 20h4V8h-4z" opacity=".25"/></svg>',
    i3:'<svg viewBox="0 0 32 32"><path d="M8 20h4V14H8zM14 20h4v-9h-4zM20 20h4V8h-4z"/></svg>',
    zitrus:'<svg viewBox="0 0 32 32"><circle cx="16" cy="16" r="10"/><path d="M16 6v20M6 16h20M9 9l14 14M23 9 9 23"/></svg>',
    bluete:'<svg viewBox="0 0 32 32"><circle cx="16" cy="16" r="3"/><path d="M16 13c-1-4 1-7 0-9-1 2 1 5 0 9ZM19 16c4-1 7 1 9 0-2-1-5 1-9 0ZM16 19c1 4-1 7 0 9 1-2-1-5 0-9ZM13 16c-4 1-7-1-9 0 2 1 5-1 9 0Z"/></svg>',
    suess:'<svg viewBox="0 0 32 32"><path d="M10 12h12l-1 14H11zM12 12c0-4 8-4 8 0"/></svg>',
    gruen:'<svg viewBox="0 0 32 32"><path d="M16 26c0-8 4-13 10-15-1 9-4 14-10 15ZM16 26C8 24 6 16 6 9c7 1 10 8 10 17Z"/></svg>',
    wuerzig:'<svg viewBox="0 0 32 32"><path d="M16 4v24M16 12c-3-1-5-3-6-6 3 0 5 2 6 6ZM16 12c3-1 5-3 6-6-3 0-5 2-6 6ZM16 20c-3-1-5-3-6-6 3 0 5 2 6 6ZM16 20c3-1 5-3 6-6-3 0-5 2-6 6Z"/></svg>',
    holz:'<svg viewBox="0 0 32 32"><path d="M16 28V6M16 13l-6-4M16 17l6-4"/></svg>',
    amber:'<svg viewBox="0 0 32 32"><circle cx="16" cy="18" r="9"/><path d="M16 9V4M13 6h6"/></svg>'
  };

  function uniq(a){ return a.filter(function(v,i){ return a.indexOf(v)===i; }); }
  function norm(s){ return (s == null ? '' : String(s)).toLowerCase(); }

  function tagsFor(p) {
    var all = [].concat(p.top || [], p.heart || [], p.base || []).map(norm).join(' | ');
    var fam = (p.family || []).map(norm);
    var nt = [];
    function has(){ for (var i=0;i<arguments.length;i++){ if (all.indexOf(arguments[i])>-1) return true; } return false; }
    if (has('orange','bergamot','zitro','lemon','limette','grapefruit','mandarine','zitrus','zitrisch','neroli')) nt.push('zitrus');
    if (has('jasmin','rose','blüt','blumig','floral','blossom','veilchen','maiglöck','ylang','orangenblüte','flieder','pfingstrose','lavendel','iris') || fam.indexOf('blumig')>-1 || fam.indexOf('floral')>-1 || fam.indexOf('pudrig')>-1) nt.push('bluete');
    if (has('vanille','tonka','karamell','honig','praline','zucker','süß','suess','sweet','kokos') || fam.indexOf('gourmand')>-1) nt.push('suess');
    if (has('grün','gruen','blatt','chlorophyll','minze','basilikum','feige','gras','tee','galbanum')) nt.push('gruen');
    if (has('safran','pfeffer','zimt','kardamom','nelke','ingwer','würz','wuerz','gewürz','muskat') || fam.indexOf('würzig')>-1 || fam.indexOf('wuerzig')>-1) nt.push('wuerzig');
    if (has('zeder','sandel','holz','harz','tannen','vetiver','patchouli','patschuli','oud','guajak','zypresse','leder','moos') || fam.indexOf('holzig')>-1) nt.push('holz');
    if (has('amber','ambra','ambrox','moschus','musk','bernstein','labdanum') || fam.indexOf('amber')>-1) nt.push('amber');
    if (has('apfel','pfirsich','melone','beere','birne','mango','ananas','frucht','litschi','cassis','pflaume','kirsche') || fam.indexOf('fruchtig')>-1) nt.push('fruchtig');

    var c = norm(p.conc);
    var intensity = c.indexOf('extrait')>-1 ? 3 : (c.indexOf('toilette')>-1 || c.indexOf('edt')>-1 ? 1 : 2);

    var ch = [];
    if (fam.indexOf('orientalisch')>-1 || fam.indexOf('amber')>-1 || fam.indexOf('gourmand')>-1 || fam.indexOf('würzig')>-1 || fam.indexOf('wuerzig')>-1) ch.push('warm');
    if (fam.indexOf('holzig')>-1 || fam.indexOf('chypre')>-1 || fam.indexOf('fougère')>-1 || fam.indexOf('fougere')>-1 || fam.indexOf('aromatisch')>-1) ch.push('holzig');
    if (fam.indexOf('blumig')>-1 || fam.indexOf('floral')>-1 || fam.indexOf('pudrig')>-1) ch.push('bluemig');
    if (fam.indexOf('fruchtig')>-1) { ch.push('fruchtig'); ch.push('frisch'); }
    if (fam.indexOf('frisch')>-1 || fam.indexOf('zitrus')>-1 || fam.indexOf('aquatisch')>-1 || fam.indexOf('aromatisch')>-1 || nt.indexOf('zitrus')>-1) ch.push('frisch');

    var occ = [];
    if (intensity >= 3 || fam.indexOf('orientalisch')>-1) occ.push('abend');
    if (intensity <= 2) { occ.push('alltag'); occ.push('buero'); occ.push('ganzjaehrig'); }

    return { nt: uniq(nt), intensity: intensity, ch: uniq(ch), occ: uniq(occ) };
  }

  function prep(p) {
    var m = (p.title || '').match(/^\s*nr\.?\s*(\d+)\s*(.*)$/i);
    p.name = m ? 'Scent ' + m[1] : p.title;
    p.sub = m ? (m[2] || '').trim() : '';
    var t = tagsFor(p);
    p.nt = t.nt; p.intensity = t.intensity; p.charr = t.ch; p.occ = t.occ;
    p.famLabel = (p.family || []).join(' · ');
    return p;
  }

  var famMap = { frisch:['fruchtig','frisch','zitrus','aquatisch','aromatisch'], fruchtig:['fruchtig'], bluemig:['blumig','floral','pudrig'], warm:['orientalisch','amber','gourmand','würzig','wuerzig'], holzig:['holzig','chypre','fougère','fougere','aromatisch'] };

  document.querySelectorAll('[data-fragrance-finder]').forEach(function (root) {
    var sid = root.id.replace(/^ff-/, '');
    var dataEl = document.getElementById('ff-data-' + sid);
    var i18nEl = document.getElementById('ff-i18n-' + sid);
    if (!dataEl || !i18nEl) return;
    var T, products;
    try {
      T = JSON.parse(i18nEl.textContent);
      products = JSON.parse(dataEl.textContent).map(prep);
    } catch (e) { return; }

    // Shopify's `t` filter HTML-escapes locale strings; undo it once so our own
    // esc() (used for innerHTML safety) doesn't double-escape (e.g. "&amp;").
    function unesc(s){ return String(s).replace(/&amp;/g,'&').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&quot;/g,'"').replace(/&#(?:39|x27);/g,"'"); }
    (function deep(o){ if (o && typeof o === 'object') { for (var k in o) { if (typeof o[k] === 'string') o[k] = unesc(o[k]); else deep(o[k]); } } })(T);

    var steps = [
      { key:'q1', title:T.q1, multi:false, cols3:true, opts:[
        { v:'sie', ic:'sie' }, { v:'ihn', ic:'ihn' }, { v:'egal', ic:'egal' } ] },
      { key:'q2', title:T.q2, multi:false, opts:[
        { v:'frisch' }, { v:'fruchtig' }, { v:'bluemig' }, { v:'warm' }, { v:'holzig' } ] },
      { key:'q3', title:T.q3, multi:false, opts:[
        { v:'alltag' }, { v:'buero' }, { v:'abend' }, { v:'ganzjaehrig' } ] },
      { key:'q4', title:T.q4, multi:false, cols3:true, opts:[
        { v:1, ic:'i1', lk:'dezent' }, { v:2, ic:'i2', lk:'ausgewogen' }, { v:3, ic:'i3', lk:'intensiv' } ] },
      { key:'q5', title:T.q5, multi:true, opts:[
        { v:'zitrus' }, { v:'bluete' }, { v:'suess' }, { v:'gruen' }, { v:'wuerzig' }, { v:'holz' }, { v:'amber' } ] }
    ];

    var state = { step:0, a:{ q1:null, q2:null, q3:null, q4:null, q5:[] } };
    var rail = root.querySelector('.ff__rail');
    var stepEl = root.querySelector('.ff__step');

    function setBar() {
      if (state.step < 1 || state.step > 5) { rail.hidden = true; return; }
      rail.hidden = false;
      rail.querySelector('span').style.right = (100 - state.step / 5 * 100) + '%';
    }
    function make(html) { var d = document.createElement('div'); d.className = 'ff__step'; d.innerHTML = html; return d; }
    function swap(node) { stepEl.replaceWith(node); stepEl = node; }
    function esc(s){ return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

    function render() {
      setBar();
      if (state.step === 0) return swap(intro());
      if (state.step <= 5) return swap(question(steps[state.step - 1]));
      return swap(result());
    }

    function intro() {
      return make(
        '<p class="ff-eyebrow">' + esc(T.eyebrow) + '</p>' +
        '<h1 class="ff-h">' + esc(T.introTitle) + '</h1>' +
        '<p class="ff-lead" style="margin:1.6rem 0 3rem">' + esc(T.introLead) + '</p>' +
        '<div class="ff-nav" style="justify-content:flex-start"><button class="ff-btn ff-btn--gold ff-btn--lg" data-go>' + esc(T.introCta) + '</button>' +
        '<span class="ff-hint" style="margin:0 0 0 .6rem">' + esc(T.introNote) + '</span></div>'
      );
    }

    function optLabel(st, o) {
      if (st.key === 'q4') return T.L[o.lk];
      return T.L[o.v];
    }
    function optSub(st, o) {
      if (st.key === 'q4') return T.S[o.lk];
      return T.S[o.v];
    }
    function question(st) {
      var sel = state.a[st.key];
      var cards = st.opts.map(function (o) {
        var on = st.multi ? sel.indexOf(o.v) > -1 : sel === o.v;
        var ic = ICON[o.ic || o.v] || '';
        var sub = optSub(st, o);
        return '<button class="ff-opt' + (on ? ' sel' : '') + '" data-v="' + o.v + '">' +
          (ic ? '<span class="ic">' + ic + '</span>' : '') +
          '<span class="tx"><b>' + esc(optLabel(st, o)) + '</b>' + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span>' +
          '<span class="tick">' + (on ? '✓' : '') + '</span></button>';
      }).join('');
      var canNext = st.multi ? sel.length > 0 : sel !== null;
      var count = (T.count || 'Frage %n% / %t%').replace('%n%', state.step).replace('%t%', 5);
      return make(
        '<p class="ff-qcount">' + esc(count) + '</p>' +
        '<h2 class="ff-h">' + esc(st.title) + '</h2>' +
        (st.multi ? '<span class="ff-hint">' + esc(T.multiHint) + '</span>' : '') +
        '<div class="ff-options' + (st.cols3 ? ' cols3' : '') + '">' + cards + '</div>' +
        '<div class="ff-nav"><button class="ff-btn ff-btn--ghost" data-back>' + esc(T.back) + '</button>' +
        '<button class="ff-btn ff-btn--gold" data-next' + (canNext ? '' : ' disabled') + '>' +
        esc(state.step === 5 ? T.showResult : T.next) + '</button></div>'
      );
    }

    function scoreOf(p) {
      var a = state.a, s = 0, max = 0, reasons = [];
      max += 3;
      if (a.q2 && (p.charr.indexOf(a.q2) > -1 || (famMap[a.q2] || []).some(function (f) { return (p.family || []).map(norm).indexOf(f) > -1; }))) { s += 3; reasons.push(T.L[a.q2]); }
      max += 2;
      if (a.q3 && p.occ.indexOf(a.q3) > -1) { s += 2; reasons.push(T.L[a.q3]); }
      max += 2;
      if (a.q4) { var d = Math.abs(p.intensity - a.q4); s += d === 0 ? 2 : (d === 1 ? 1 : 0); }
      max += 3;
      if (a.q5 && a.q5.length) {
        var mm = a.q5.filter(function (n) { return p.nt.indexOf(n) > -1; });
        s += Math.min(3, mm.length * 1.2);
        mm.forEach(function (n) { reasons.push(T.L[n]); });
      }
      if (a.q1 && a.q1 !== 'egal' && p.gender && norm(p.gender) !== 'unisex' && norm(p.gender).indexOf(a.q1) < 0) s -= 100;
      return { p: p, s: s, pct: Math.max(35, Math.min(99, Math.round(s / max * 100))), reasons: uniq(reasons).slice(0, 5) };
    }

    function result() {
      if (!products.length) return make('<p class="ff-lead">—</p>');
      var ranked = products.map(scoreOf).sort(function (a, b) { return b.s - a.s; });
      var win = ranked[0], alts = ranked.slice(1, 3), ch = win.p;
      var chips = win.reasons.map(function (r) { return '<span class="ff-chip on">' + esc(r) + '</span>'; }).join('');
      var alt = alts.map(function (r) {
        return '<a class="ff-altcard" href="' + esc(r.p.url) + '">' +
          '<span class="th" style="background-image:url(' + esc(r.p.img) + ')"></span>' +
          '<span><b>' + esc(r.p.name) + '</b><small>' + esc(r.p.sub) + (r.p.famLabel ? ' · ' + esc(r.p.famLabel) : '') + '</small></span>' +
          '<span class="mini">' + r.pct + '%</span></a>';
      }).join('');
      var node = make(
        '<p class="ff-eyebrow">' + esc(T.resultEyebrow) + '</p>' +
        '<h2 class="ff-h" style="margin-bottom:1.8rem">' + esc(T.resultTitle) + '</h2>' +
        '<div class="ff-res">' +
          '<div class="media" style="background-image:url(' + esc(ch.img) + ')"></div>' +
          '<div class="info">' +
            (ch.famLabel ? '<p class="fam">' + esc(ch.famLabel) + '</p>' : '') +
            '<p class="name">' + esc(ch.name) + (ch.sub ? ' <span>· ' + esc(ch.sub) + '</span>' : '') + '</p>' +
            '<div class="ff-match"><span class="pct">' + win.pct + '%</span><span class="barwrap"><i></i></span></div>' +
            '<div class="ff-why"><span class="ff-chip">' + esc(T.because) + '</span>' + chips + '</div>' +
            (ch.inspired ? '<p class="ff-inspired">' + esc(T.inspiredPrefix) + ' ' + esc(ch.inspired) + '</p>' : '') +
            '<div class="ff-facts">' +
              (ch.conc ? '<div><span>' + esc(T.concLabel) + '</span>' + esc(ch.conc) + '</div>' : '') +
              (ch.longevity ? '<div><span>' + esc(T.longevityLabel) + '</span>' + esc(ch.longevity) + '</div>' : '') +
              ((ch.top && ch.top.length) ? '<div><span>' + esc(T.topLabel) + '</span>' + esc(ch.top.join(', ')) + '</div>' : '') +
            '</div>' +
            '<div class="ff-cta">' +
              (ch.available && ch.vid ? '<button class="ff-btn ff-btn--gold" data-cart="' + ch.vid + '">' + esc(T.ctaCart) + '</button>' : '') +
              '<a class="ff-btn" href="' + esc(ch.url) + '">' + esc(T.ctaDetails) + '</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
        (alt ? '<div class="ff-alts"><h3>' + esc(T.altsTitle) + '</h3><p class="sub">' + esc(T.altsSub) + '</p><div class="ff-altgrid">' + alt + '</div></div>' : '') +
        '<div class="ff-nav" style="justify-content:center;margin-top:3rem"><button class="ff-btn ff-btn--ghost" data-restart>' + esc(T.restart) + '</button></div>'
      );
      requestAnimationFrame(function () { var i = node.querySelector('.ff-match .barwrap>i'); if (i) i.style.width = win.pct + '%'; });
      return node;
    }

    function addToCart(vid) {
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ id:vid, quantity:1 }) })
        .then(function (r) { return r.json(); })
        .then(function () { window.location = '/cart'; })
        .catch(function () { window.location = '/cart'; });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-go')) { state.step = 1; return render(); }
      if (t.hasAttribute('data-back')) { state.step = Math.max(0, state.step - 1); return render(); }
      if (t.hasAttribute('data-next')) { state.step++; return render(); }
      if (t.hasAttribute('data-restart')) { state.step = 0; state.a = { q1:null,q2:null,q3:null,q4:null,q5:[] }; return render(); }
      if (t.hasAttribute('data-cart')) { e.preventDefault(); return addToCart(t.getAttribute('data-cart')); }
      if (t.classList.contains('ff-opt')) {
        var st = steps[state.step - 1], v = t.getAttribute('data-v');
        if (st.key === 'q4') v = parseInt(v, 10);
        if (st.multi) { var arr = state.a[st.key], i = arr.indexOf(v); if (i > -1) arr.splice(i, 1); else arr.push(v); }
        else { state.a[st.key] = v; }
        return render();
      }
    });

    render();
  });
})();
